export interface ListResponse<T> {
  total_results: number
  previous_page: string | null
  next_page: string | null
  resources: T[]
}

export interface FetchListParams {
  search_text?: string
  filter?: string
  sort_by?: string
  sort_order?: string
  start_index?: string
  count?: number
  bypass_pagination?: boolean
  pta?: string
  codespace_id?: string
}

export enum DeleteModes {
  SAFE = 'SAFE',
  FORCE = 'FORCE',
  CASCADE = 'CASCADE',
  CLEAN = 'CLEAN'
}

export interface DeleteParams {
  mode?: DeleteModes
}
